import { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Collapse, Toggle, Body1 } from '../../../cdl-react-components/components'
import { getOffset } from '../../../cdl-react-components/utilities'

class ContentTypeTooltip extends Component {
    hiddenClass = 'hidden'

    constructor(props) {
        super(props)
        this.element = document.createElement('div')
        this.element.classList.add('content-type-tooltip')
        this.element.classList.add(this.hiddenClass)
    }

    renderContent = () => {
        return (
            <Body1>{this.props.children}</Body1>
        )
    }

    render() {
        const { open, target } = this.props

        if (open) {
            const offset = getOffset(target)
            this.element.style.top = `${offset.top}px`
            this.element.style.left = `${offset.left}px`
            this.element.classList.remove(this.hiddenClass)
        } 
        else
            this.element.classList.add(this.hiddenClass)

        return ReactDOM.createPortal(
                this.renderContent(),
                this.element)
    }

    componentDidMount() {
        document.body.appendChild(this.element)
    }

    componentWillUnmount() {
        document.body.removeChild(this.element)
    }
}

class ContentTypes extends Component {
    state = {
        activeConfig: undefined,
        target: undefined,
        contentTypeConfig: [
            { id: 'articles', name: 'Articles', description: 'Discovery Digest articles cover a range of zones, plays and topics across the WCSB and include maps, graphs, logs and technical analysis. Topics include drilling, production and land activity, completions and production analyses, and play reviews.' },
            { id: 'regionalMaps', name: 'CDL Map Series', description: 'The CDL Map Series are compiled from data pulled from CDL’s regional studies. Currently geothermal, isotherm, stress and geochemistry maps are available for several zones. Hydrodynamics maps will be coming soon. Contact CDL if you are interested in purchasing shapefiles and geotiffs.' },
            { id: 'activityMaps', name: 'Activity Wall Maps', description: 'Digest Activity Wall Maps are published twice a year and are suitable for boardrooms. Each map covers the WCSB and includes drilling, production and Crown land activity, as well as top producing wells.' },
        ]
    }

    showTooltip = (e, contentType) => this.setState({ activeConfig: contentType, target: e.target })
    hideTooltip = () => this.setState({ activeConfig: undefined, target: undefined })

    render() {
        const { activeConfig, target, contentTypeConfig } = this.state
        return (
            <Collapse open title="Categories" className="search__content-type">
                { contentTypeConfig && contentTypeConfig.map((x, i) => (
                    <div key={'search__content-type__item--' + i}
                         className="search__content-type__item">
                        <Toggle
                            type="switch"
                            checked={this.props.contentTypes[x.id]}
                            onChange={this.props.handelContentTypeChange(x.id)}>
                            {x.name}
                        </Toggle>
                        <div className="search__content-type__tooltip">
                            <div className="search__content-type__tooltip__icon"
                                onMouseOver={e => this.showTooltip(e, x)}
                                onMouseOut={this.hideTooltip}>
                                    <img src="https://webfiles.canadiandiscovery.com/public/CDD/images/info-icon.svg" alt="i"/>
                                </div>
                        </div>
                    </div>
                ))}
                <ContentTypeTooltip open={!!activeConfig} target={target}>
                    { activeConfig && activeConfig.description }
                </ContentTypeTooltip>
            </Collapse>
        )
    }
}

ContentTypes.propTypes = {
    contentTypes: PropTypes.object.isRequired,
    handelContentTypeChange: PropTypes.func.isRequired
}

export default ContentTypes